module.exports = __webpack_public_path__ + "img/text-file.eac22ff1.svg";